import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '@fb-tool-front/core/services/auth.service';
import { localStorageOnboarding } from '@fb-tool-front/shared/constants/shared.constant';
import { User } from '@fb-tool-front/shared/interfaces/auth.type';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class OnboardingOverlaysStepperGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate() {
    return this.authService.userData$.pipe(
      filter(res => !!res),
      map((data: User['data']) => {
        if (data?.[localStorageOnboarding]) {
          this.router.navigate(['overlays']);

          return false;
        }

        return true;
      })
    );
  }
}
